// @ts-nocheck
// get all partial events requests
export const FETCH_PARTIAL_EVENTS_REQUEST = "FETCH_PARTIAL_EVENTS_REQUEST";
export const FETCH_PARTIAL_EVENTS_SUCCESS = "FETCH_PARTIAL_EVENTS_SUCCESS";
export const FETCH_PARTIAL_EVENTS_FAILURE = "FETCH_PARTIAL_EVENTS_FAILURE";